module.exports = __webpack_public_path__ + "img/IMG_20200821_075805.e35a6568.e35a6568.jpg";